import { render, staticRenderFns } from "./DocumentPortalSetupLinkView.vue?vue&type=template&id=5637d8e4&scoped=true&"
import script from "./DocumentPortalSetupLinkView.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalSetupLinkView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalSetupLinkView.vue?vue&type=style&index=0&id=5637d8e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5637d8e4",
  null
  
)

export default component.exports